export default __webpack_public_path__ + "static/media/location-la.2afc238b.jpg";